
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-report",
  components: {},
})
export default class IconReport extends Vue {
  @Prop() public width!: number;
  @Prop() public height!: number;
  @Prop() public color!: string;

  constructor() {
    super();
  }
}
